import React from "react";

// QR code (rendered by the backend as a data URL) plus the manual setup key.
const AuthenticatorSetup = ({ setup }) => (
  <div className="text-center mb-3">
    <img
      src={setup.qrCodeDataUrl}
      alt="Authenticator QR code"
      style={{ width: 200, height: 200, imageRendering: "pixelated" }}
    />
    <div
      className="mt-2"
      style={{ fontFamily: "monospace", fontSize: 16, letterSpacing: 1, wordBreak: "break-all" }}
    >
      {setup.manualKey}
    </div>
  </div>
);

export default AuthenticatorSetup;
